<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M6.117 7.217a2.57 2.57 0 0 1-.784-1.884q0-1.099.784-1.883A2.57 2.57 0 0 1 8 2.667q1.1 0 1.883.783.784.783.784 1.883t-.784 1.884A2.57 2.57 0 0 1 8 8a2.57 2.57 0 0 1-1.883-.783m-3.45 6.116v-1.866q0-.567.291-1.042.292-.475.775-.725a10 10 0 0 1 2.1-.775 9.2 9.2 0 0 1 4.334 0q1.065.258 2.1.775.483.25.775.725.291.475.291 1.042v1.866zM4 12h8v-.533a.65.65 0 0 0-.333-.567 8.7 8.7 0 0 0-1.817-.675 7.7 7.7 0 0 0-3.7 0 8.7 8.7 0 0 0-1.817.675.65.65 0 0 0-.333.567zm4.942-5.725q.39-.391.391-.942 0-.55-.391-.941A1.28 1.28 0 0 0 8 4q-.55 0-.942.392a1.28 1.28 0 0 0-.391.941q0 .55.391.942.392.392.942.392t.942-.392"
        />
    </svg>
</template>

<script setup lang="ts">
type UserIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<UserIconProps>();
</script>
